import React from 'react';
import { Col, Spinner } from 'react-bootstrap';
import Icon from '../../Icons';
import HRDashboardStyled from '../../HRDashboardStyled';

const ShiftAssigmentsCard = ({ cards, handleMoreInfoButton, showSpinner, hasRoleShiftAssignment }) => {
  const todayShiftAssignments = cards?.shiftAssignmentsStartTodayCount || 0;

  return (
    <>
      {showSpinner ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <>
          <HRDashboardStyled
            title={todayShiftAssignments}
            label="Asignación de Turnos"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#f8c444"
            subtitle="Asignación(es) de turno para hoy"
            TypeCard="OnlyInformation"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          {
            <button
              type="button"
              onClick={handleMoreInfoButton}
              style={{
                border: hasRoleShiftAssignment ? '1px solid #65b68f' : '1px solid #ccc',
                backgroundColor: hasRoleShiftAssignment ? '#65b68f' : '#ccc',
                position: 'absolute',
                right: 20,
                bottom: 10,
                cursor: hasRoleShiftAssignment ? 'pointer' : 'not-allowed'
              }}
              disabled={!hasRoleShiftAssignment}
            >
              <Icon icon="search" height="25px" width="16px" color="white" />
            </button>
          }
        </>
      )}
    </>
  );
};

export default ShiftAssigmentsCard;
